import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Fragment } from 'react';
import { NavMarker } from 'react-rhumb';
import { Route, Switch } from 'react-router-dom';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import UIRouterNavButton from 'ui-addon-react-router-dom/UIRouterNavButton';
import DocumentHead from 'ecosystem-marketplace-core/components/portals/DocumentHead';
import PrerenderReady from 'ecosystem-marketplace-core/components/prerender/PrerenderReady';
import PrerenderStatusCode from 'ecosystem-marketplace-core/components/prerender/PrerenderStatusCode';
import App from '../containers/App';
import Home from '../containers/Home';

const Routes = () => /*#__PURE__*/_jsx(App, {
  children: /*#__PURE__*/_jsxs(Switch, {
    children: [/*#__PURE__*/_jsx(Route, {
      component: Home,
      exact: true,
      path: "/(/?)"
    }), /*#__PURE__*/_jsx(Route, {
      children: /*#__PURE__*/_jsxs(NavMarker, {
        name: "NOT_FOUND_ERROR_LOAD",
        children: [/*#__PURE__*/_jsx(DocumentHead, {
          children: /*#__PURE__*/_jsxs(Fragment, {
            children: [/*#__PURE__*/_jsx(PrerenderStatusCode, {
              statusCode: 404
            }), /*#__PURE__*/_jsx(PrerenderReady, {})]
          })
        }), /*#__PURE__*/_jsx(UIErrorMessage, {
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplaceUnified.notFoundError.title"
          }),
          type: "notFound",
          children: /*#__PURE__*/_jsx(UIRouterNavButton, {
            className: "m-top-4",
            exact: true,
            to: "/",
            use: "tertiary",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplaceUnified.notFoundError.button"
            })
          })
        })]
      })
    })]
  })
});

export default Routes;